<template>
  <div id="patternlockContainer">
    <div class="flex h-[254px] items-center text-gray-600"><i-mdi:loading class="h-16 w-16 animate-spin" /></div>
  </div>
</template>

<script setup lang="ts">
// alphabet, mapper function and styles are taken from didab.net

// @ts-expect-error patternlock is not typed
import Patternlock from 'patternlock/dist/patternlock.es.js';
import 'patternlock/dist/patternlock.css';

const emits = defineEmits<{
  updatePassword: [string];
}>();

const alphabet = ['abcdefghijklmnopqrs', 'ABCDEFGHIJKLMNOPQRS', '0123456789012345678', '[(!"$%&/=?+*~_;,@)]'];

onMounted(() => {
  const lock = new Patternlock(`#patternlockContainer`, {
    margin: 10,
    radius: 29,
    mapper: () => {
      if (lock.getPattern().length >= 4) {
        let xPassword = '';

        for (let i = 0; i < lock.getPattern().length; i++) {
          const xChar = Number(lock.getPattern().charAt(i));

          xPassword += alphabet[i % alphabet.length]![xChar - 1];
          xPassword += alphabet[(i + 1) % alphabet.length]![xChar];
        }
        emits('updatePassword', xPassword);
      }
    },
  });
});
</script>

<style scoped>
#patternlockContainer {
  background-color: transparent !important;
}

#patternlockContainer:deep(.patt-wrap .patt-circ) {
  background-color: #3e4e59;
  border: 2px solid #cf112d !important;
  position: relative;
  list-style-type: none;
  padding: 0;
}

#patternlockContainer:deep(.patt-wrap .patt-circ .patt-dots) {
  margin: 0;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: #fff;
}

#patternlockContainer:deep(.patt-wrap .patt-circ.hovered .patt-dots) {
  background-color: #cf112d;
}

#patternlockContainer:deep(.patt-lines) {
  border-radius: 5px;
  height: 10px;
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  transform-origin: 5px 5px;
}
</style>
